// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let ReactRelay = require("react-relay");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function makeRefetchVariables(propertyData) {
  return {
    propertyData: propertyData
  };
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

let variablesConverter = {"rentalPropertyDataInput":{"availableFrom":{"b":""}},"draftPriceRangeInput":{"minPrice":{"b":""},"maxPrice":{"b":""}},"attachmentV5Input":{},"draftExactPriceInput":{"price":{"b":""}},"draftPropertyV5GeocodingDataInput":{},"forSalePropertyDataInput":{},"draftPropertyPriceInput":{"priceRange":{"r":"draftPriceRangeInput"},"exactPrice":{"r":"draftExactPriceInput"}},"draftPropertyV5Input":{"showings":{"r":"draftShowingV5Input"},"rentalProperty":{"r":"rentalPropertyDataInput"},"price":{"r":"draftPropertyPriceInput"},"onMlsAt":{"b":""},"images":{"r":"attachmentV5Input"},"geocodingData":{"r":"draftPropertyV5GeocodingDataInput"},"forSaleProperty":{"r":"forSalePropertyDataInput"},"files":{"r":"attachmentV5Input"}},"draftShowingV5Input":{"date":{"b":""}},"__root":{"propertyData":{"r":"draftPropertyV5Input"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"propertyPreviewHelpers":{"f":""}}};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, undefined, null);
}

let responseConverter = {"__root":{"propertyPreviewHelpers":{"f":""}}};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, undefined, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: undefined,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: undefined,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function forSalePropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY" || $$enum === "LOT" || $$enum === "MULTI_UNIT") {
    return $$enum;
  }
}

let forSalePropertyTypeEnumV5_fromString = forSalePropertyTypeEnumV5_decode;

function leaseLengthValue_decode($$enum) {
  if ($$enum === "LONG" || $$enum === "SHORT_OR_LONG" || $$enum === "SHORT") {
    return $$enum;
  }
}

let leaseLengthValue_fromString = leaseLengthValue_decode;

function lotSizeUnit_decode($$enum) {
  if ($$enum === "ACRE" || $$enum === "SQ_FT") {
    return $$enum;
  }
}

let lotSizeUnit_fromString = lotSizeUnit_decode;

function mlsListingTypeV5_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "OFF_MLS" || $$enum === "COMING_SOON") {
    return $$enum;
  }
}

let mlsListingTypeV5_fromString = mlsListingTypeV5_decode;

function rentalPropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY") {
    return $$enum;
  }
}

let rentalPropertyTypeEnumV5_fromString = rentalPropertyTypeEnumV5_decode;

function showingTypeV5_decode($$enum) {
  if ($$enum === "AGENTS_ONLY" || $$enum === "TAN_ONLY" || $$enum === "BUYERS_WELCOME") {
    return $$enum;
  }
}

let showingTypeV5_fromString = showingTypeV5_decode;

let Utils = {
  forSalePropertyTypeEnumV5_decode: forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: forSalePropertyTypeEnumV5_fromString,
  leaseLengthValue_decode: leaseLengthValue_decode,
  leaseLengthValue_fromString: leaseLengthValue_fromString,
  lotSizeUnit_decode: lotSizeUnit_decode,
  lotSizeUnit_fromString: lotSizeUnit_fromString,
  mlsListingTypeV5_decode: mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: mlsListingTypeV5_fromString,
  rentalPropertyTypeEnumV5_decode: rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: rentalPropertyTypeEnumV5_fromString,
  showingTypeV5_decode: showingTypeV5_decode,
  showingTypeV5_fromString: showingTypeV5_fromString
};

let providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyData"
},
v1 = [
  {
    "kind": "Variable",
    "name": "propertyData",
    "variableName": "propertyData"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "format",
        "value": "FULL"
      }
    ],
    "kind": "ScalarField",
    "name": "formatted",
    "storageKey": "formatted(format:\"FULL\")"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "beds",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baths",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "halfBaths",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "LotSize",
  "kind": "LinkedField",
  "name": "lotSizeV2",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "livingArea",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willShowPriorToMls",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willAcceptOffersPriorToMls",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationDisplay",
  "storageKey": null
},
v13 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lat",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lon",
    "storageKey": null
  }
],
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "CoordinatesV5",
  "kind": "LinkedField",
  "name": "approximateCoordinates",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibilityRule",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "CoordinatesV5",
  "kind": "LinkedField",
  "name": "coordinates",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "membershipStatus",
  "storageKey": null
},
v20 = {
  "kind": "Variable",
  "name": "ratio",
  "variableName": "__relay_internal__pv__DevicePixelRatio"
},
v21 = {
  "kind": "Literal",
  "name": "width",
  "value": 60
},
v22 = {
  "kind": "Literal",
  "name": "width",
  "value": 1200
},
v23 = {
  "kind": "Literal",
  "name": "embed",
  "value": true
},
v24 = {
  "kind": "Literal",
  "name": "crop",
  "value": true
},
v25 = {
  "kind": "Literal",
  "name": "height",
  "value": 284
},
v26 = {
  "kind": "Literal",
  "name": "width",
  "value": 426
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PropertyWizardRelayPreviewQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*: any*/),
          "concreteType": "PropertyPreviewHelpers",
          "kind": "LinkedField",
          "name": "propertyPreviewHelpers",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PropertyWizardRelayPreview_displayHelpers"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "PropertyWizardRelayPreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PropertyPreviewHelpers",
        "kind": "LinkedField",
        "name": "propertyPreviewHelpers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "price",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isPropertyPrice"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Price",
                    "kind": "LinkedField",
                    "name": "minPrice",
                    "plural": false,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Price",
                    "kind": "LinkedField",
                    "name": "maxPrice",
                    "plural": false,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "PriceRange",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Price",
                    "kind": "LinkedField",
                    "name": "price",
                    "plural": false,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "ExactPrice",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LeaseLengthV5",
            "kind": "LinkedField",
            "name": "leaseLength",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CondoProperty",
            "kind": "LinkedField",
            "name": "condoProperty",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "parkingSpaces",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "parkingDetails",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LotProperty",
            "kind": "LinkedField",
            "name": "lotProperty",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MultiUnitProperty",
            "kind": "LinkedField",
            "name": "multiUnitProperty",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numberOfUnits",
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SingleFamilyProperty",
            "kind": "LinkedField",
            "name": "singleFamilyProperty",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "mlsPlan",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isMlsPlan"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "onMlsAt",
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  (v11/*: any*/)
                ],
                "type": "ListOnMlsAsActive",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "activeOnMlsOn",
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  (v11/*: any*/)
                ],
                "type": "ListOnMlsAsComingSoon",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "willShow",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "willAcceptOffers",
                    "storageKey": null
                  }
                ],
                "type": "NoMlsPlan",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "propertyLocation",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isPropertyLocation"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v12/*: any*/),
                  (v14/*: any*/)
                ],
                "type": "PropertyLocationWithHiddenAddress",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v15/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "address",
                    "storageKey": null
                  },
                  (v16/*: any*/)
                ],
                "type": "PropertyLocationWithVisibleAddress",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ShowingV5",
            "kind": "LinkedField",
            "name": "showings",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              (v17/*: any*/),
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDateV2",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endDateV2",
                "storageKey": null
              },
              {
                "alias": "type_",
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notes",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "agentV2",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v19/*: any*/)
                ],
                "type": "HiddenPropertyPreviewAgent",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Agent",
                    "kind": "LinkedField",
                    "name": "agent",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phone",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "emailAddress",
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "brokerage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfilePhoto",
                        "kind": "LinkedField",
                        "name": "profilePhoto",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              (v20/*: any*/),
                              (v21/*: any*/)
                            ],
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          },
                          {
                            "alias": "urlWithRing",
                            "args": [
                              (v20/*: any*/),
                              {
                                "kind": "Literal",
                                "name": "ring",
                                "value": true
                              },
                              (v21/*: any*/)
                            ],
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v19/*: any*/),
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "VisiblePropertyPreviewAgent",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PropertyLocationWithHiddenAddress",
            "kind": "LinkedField",
            "name": "hiddenPropertyLocation",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v15/*: any*/),
                      (v16/*: any*/)
                    ],
                    "type": "PropertyLocationWithVisibleAddress",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v14/*: any*/)
                    ],
                    "type": "PropertyLocationWithHiddenAddress",
                    "abstractKey": null
                  }
                ],
                "type": "PropertyLocation",
                "abstractKey": "__isPropertyLocation"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ImageAttachment",
            "kind": "LinkedField",
            "name": "images",
            "plural": true,
            "selections": [
              {
                "alias": "carouselFullscreen",
                "args": [
                  (v20/*: any*/),
                  (v22/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": "carouselLarge",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "height",
                    "value": 800
                  },
                  (v20/*: any*/),
                  (v22/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": "carouselSmall",
                "args": [
                  (v23/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "height",
                    "value": 500
                  },
                  (v20/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "width",
                    "value": 750
                  }
                ],
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": "carouselThumb",
                "args": [
                  (v24/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "height",
                    "value": 90
                  },
                  (v20/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "width",
                    "value": 90
                  }
                ],
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": "large",
                "args": [
                  (v24/*: any*/),
                  (v23/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "height",
                    "value": 720
                  },
                  (v20/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "width",
                    "value": 1288
                  }
                ],
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": "medium",
                "args": [
                  (v24/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "height",
                    "value": 574
                  },
                  (v20/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "width",
                    "value": 861
                  }
                ],
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": "small",
                "args": [
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v20/*: any*/),
                  (v26/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": "imgUrl",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "crop",
                    "value": false
                  },
                  (v23/*: any*/),
                  (v25/*: any*/),
                  (v20/*: any*/),
                  (v26/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              (v17/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "website",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FileAttachment",
            "kind": "LinkedField",
            "name": "files",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "contentType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fileName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              (v17/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "805c9648b33fa9e7199e6362f6581d11",
    "id": null,
    "metadata": {},
    "name": "PropertyWizardRelayPreviewQuery",
    "operationKind": "query",
    "text": "query PropertyWizardRelayPreviewQuery(\n  $propertyData: DraftPropertyV5Input!\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  propertyPreviewHelpers(propertyData: $propertyData) {\n    ...PropertyWizardRelayPreview_displayHelpers\n  }\n}\n\nfragment AgentInfo_agent on Agent {\n  id\n  displayName\n  brokerage\n  profilePhoto {\n    url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n    urlWithRing: url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio, ring: true)\n  }\n  membershipStatus\n}\n\nfragment AgentPropertyLocation_propertyLocation on PropertyLocation {\n  __isPropertyLocation: __typename\n  __typename\n  ... on PropertyLocationWithHiddenAddress {\n    locationDisplay\n  }\n  ... on PropertyLocationWithVisibleAddress {\n    visibilityRule\n    locationDisplay\n    address\n  }\n}\n\nfragment AgentPropertyMlsStatus_mlsPlan on MlsPlan {\n  __isMlsPlan: __typename\n  __typename\n  ... on AlreadyOnMls {\n    __typename\n  }\n  ... on ListOnMlsAsActive {\n    onMlsAt\n  }\n  ... on ListOnMlsAsComingSoon {\n    activeOnMlsOn\n  }\n  ... on NoMlsPlan {\n    willShow\n  }\n}\n\nfragment ContactAgentButton_agent on Agent {\n  phone\n  emailAddress\n  displayName\n}\n\nfragment FileList_file on FileAttachment {\n  contentType\n  fileName\n  url\n}\n\nfragment FileList_files on FileAttachment {\n  ...FileList_file\n}\n\nfragment ForSalePropertyAttributesCondo_condoProperty on CondoProperty {\n  beds\n  baths\n  halfBaths\n  lotSizeV2 {\n    value\n    unit\n  }\n  livingArea\n  displayName\n}\n\nfragment ForSalePropertyAttributesLot_lotProperty on LotProperty {\n  lotSizeV2 {\n    value\n    unit\n  }\n  displayName\n}\n\nfragment ForSalePropertyAttributesMultiUnit_multiUnitProperty on MultiUnitProperty {\n  numberOfUnits\n  displayName\n}\n\nfragment ForSalePropertyAttributesSingleFamily_singleFamilyProperty on SingleFamilyProperty {\n  beds\n  baths\n  halfBaths\n  lotSizeV2 {\n    value\n    unit\n  }\n  livingArea\n  displayName\n}\n\nfragment ImageGalleryAllImages_image on ImageAttachment {\n  imgUrl: url(width: 426, height: 284, crop: false, embed: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n  key\n}\n\nfragment ImageGalleryGridImage_image on ImageAttachment {\n  large: url(width: 1288, height: 720, crop: true, embed: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n  medium: url(width: 861, height: 574, crop: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n  small: url(width: 426, height: 284, crop: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n}\n\nfragment ImageGalleryGrid_image on ImageAttachment {\n  ...ImageGalleryGridImage_image\n}\n\nfragment ImageGallery_image on ImageAttachment {\n  carouselFullscreen: url(width: 1200, ratio: $__relay_internal__pv__DevicePixelRatio)\n  carouselLarge: url(width: 1200, height: 800, ratio: $__relay_internal__pv__DevicePixelRatio)\n  carouselSmall: url(width: 750, height: 500, embed: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n  carouselThumb: url(width: 90, height: 90, crop: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n  ...ImageGalleryGrid_image\n  ...ImageGalleryAllImages_image\n}\n\nfragment MlsPlanListingDetails_mlsPlan on MlsPlan {\n  __isMlsPlan: __typename\n  __typename\n  ... on AlreadyOnMls {\n    __typename\n  }\n  ... on ListOnMlsAsActive {\n    onMlsAt\n    willAcceptOffersPriorToMls\n    willShowPriorToMls\n  }\n  ... on ListOnMlsAsComingSoon {\n    activeOnMlsOn\n    willAcceptOffersPriorToMls\n    willShowPriorToMls\n  }\n  ... on NoMlsPlan {\n    willShow\n    willAcceptOffers\n  }\n}\n\nfragment OwnAnonymousAgentInfo_agent on Agent {\n  id\n  displayName\n  brokerage\n  profilePhoto {\n    url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n  }\n}\n\nfragment PropertyLocationMapInner_location on PropertyLocation {\n  __isPropertyLocation: __typename\n  __typename\n  ... on PropertyLocationWithVisibleAddress {\n    visibilityRule\n    coordinates {\n      lat\n      lon\n    }\n  }\n  ... on PropertyLocationWithHiddenAddress {\n    approximateCoordinates {\n      lat\n      lon\n    }\n  }\n}\n\nfragment PropertyPageNextShowing_showing on ShowingV5 {\n  startDate\n}\n\nfragment PropertyPrice_propertyPrice_4wzfKn on PropertyPrice {\n  __isPropertyPrice: __typename\n  __typename\n  ... on PriceRange {\n    minPrice {\n      formatted(format: FULL)\n    }\n    maxPrice {\n      formatted(format: FULL)\n    }\n  }\n  ... on ExactPrice {\n    price {\n      formatted(format: FULL)\n    }\n  }\n}\n\nfragment PropertyShowingsList_showing on ShowingV5 {\n  startDateV2\n  endDateV2\n  type_: type\n  notes\n}\n\nfragment PropertyShowingsList_showings on ShowingV5 {\n  id\n  ...PropertyShowingsList_showing\n}\n\nfragment PropertyWizardRelayPreviewFiles_previewHelpers on PropertyPreviewHelpers {\n  files {\n    ...FileList_files\n    nodeId\n  }\n}\n\nfragment PropertyWizardRelayPreviewImageGrid_displayHelpers on PropertyPreviewHelpers {\n  images {\n    ...ImageGallery_image\n    nodeId\n  }\n}\n\nfragment PropertyWizardRelayPreviewListingDetails_previewHelpers on PropertyPreviewHelpers {\n  showings {\n    startDate\n    nodeId\n  }\n  condoProperty {\n    parkingSpaces\n    parkingDetails\n  }\n  mlsPlan {\n    __typename\n    ...MlsPlanListingDetails_mlsPlan\n  }\n  website\n}\n\nfragment PropertyWizardRelayPreviewLocation_displayHelpers on PropertyPreviewHelpers {\n  propertyLocation {\n    __typename\n    ...PropertyLocationMapInner_location\n  }\n  hiddenPropertyLocation {\n    ...PropertyLocationMapInner_location\n  }\n}\n\nfragment PropertyWizardRelayPreviewMobileAgentInfoSection_previewHelpers on PropertyPreviewHelpers {\n  agentV2 {\n    __typename\n    ... on HiddenPropertyPreviewAgent {\n      membershipStatus\n    }\n    ... on VisiblePropertyPreviewAgent {\n      visibilityRule\n      agent {\n        ...AgentInfo_agent\n        ...OwnAnonymousAgentInfo_agent\n        nodeId\n      }\n    }\n  }\n}\n\nfragment PropertyWizardRelayPreviewPropertyDetailsStreetAddress_displayHelpers on PropertyPreviewHelpers {\n  propertyLocation {\n    __typename\n    ...AgentPropertyLocation_propertyLocation\n  }\n}\n\nfragment PropertyWizardRelayPreviewPropertyDetails_displayHelpers on PropertyPreviewHelpers {\n  price {\n    __typename\n    ...PropertyPrice_propertyPrice_4wzfKn\n  }\n  leaseLength {\n    displayName\n  }\n  condoProperty {\n    ...ForSalePropertyAttributesCondo_condoProperty\n  }\n  lotProperty {\n    ...ForSalePropertyAttributesLot_lotProperty\n  }\n  multiUnitProperty {\n    ...ForSalePropertyAttributesMultiUnit_multiUnitProperty\n  }\n  singleFamilyProperty {\n    ...ForSalePropertyAttributesSingleFamily_singleFamilyProperty\n  }\n  mlsPlan {\n    __typename\n    ...AgentPropertyMlsStatus_mlsPlan\n  }\n  ...PropertyWizardRelayPreviewPropertyDetailsStreetAddress_displayHelpers\n}\n\nfragment PropertyWizardRelayPreviewShowingsList_displayHelpers on PropertyPreviewHelpers {\n  showings {\n    ...PropertyShowingsList_showings\n    nodeId\n  }\n}\n\nfragment PropertyWizardRelayPreviewSidecardMlsInfo_mlsPlan on MlsPlan {\n  __isMlsPlan: __typename\n  __typename\n  ... on ListOnMlsAsActive {\n    onMlsAt\n    willShowPriorToMls\n    willAcceptOffersPriorToMls\n  }\n  ... on ListOnMlsAsComingSoon {\n    activeOnMlsOn\n    willShowPriorToMls\n    willAcceptOffersPriorToMls\n  }\n  ... on NoMlsPlan {\n    willShow\n    willAcceptOffers\n  }\n}\n\nfragment PropertyWizardRelayPreviewSidecard_displayHelpers on PropertyPreviewHelpers {\n  showings {\n    ...PropertyPageNextShowing_showing\n    nodeId\n  }\n  agentV2 {\n    __typename\n    ... on HiddenPropertyPreviewAgent {\n      membershipStatus\n    }\n    ... on VisiblePropertyPreviewAgent {\n      visibilityRule\n      agent {\n        ...ContactAgentButton_agent\n        ...AgentInfo_agent\n        ...OwnAnonymousAgentInfo_agent\n        nodeId\n      }\n    }\n  }\n  mlsPlan {\n    __typename\n    ...PropertyWizardRelayPreviewSidecardMlsInfo_mlsPlan\n  }\n}\n\nfragment PropertyWizardRelayPreview_displayHelpers on PropertyPreviewHelpers {\n  ...PropertyWizardRelayPreviewPropertyDetails_displayHelpers\n  ...PropertyWizardRelayPreviewPropertyDetailsStreetAddress_displayHelpers\n  ...PropertyWizardRelayPreviewSidecard_displayHelpers\n  ...PropertyWizardRelayPreviewShowingsList_displayHelpers\n  ...PropertyWizardRelayPreviewLocation_displayHelpers\n  ...PropertyWizardRelayPreviewImageGrid_displayHelpers\n  ...PropertyWizardRelayPreviewListingDetails_previewHelpers\n  ...PropertyWizardRelayPreviewMobileAgentInfoSection_previewHelpers\n  ...PropertyWizardRelayPreviewFiles_previewHelpers\n  files {\n    __typename\n    nodeId\n  }\n  images {\n    __typename\n    nodeId\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

let node = makeNode(providedVariablesDefinition);

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
